import http from '@/biz/http.mjs'
import parseMap from '../../../scripts/parseMap.mjs'

export const canUndoReviseMap = () => () => {
    return function () {
        if (! /^REVISE$/.test(this.data.mapStsCode)) {
            this.logger.error('只有修订状态的地图才能撤销修订')
            return false
        }

        if (! this.permission.has('write')) {
            this.logger.error('没有撤销修订权限')
            return false
        }

        return true
    }
}

export const undoReviseMap = () => () => {
    return function () {
        return this.execute(
            () => this.runAction(
                async () => {
                    const {pkid, prjId, sVer} = this.data

                    const {dataMap} = await http.get(
                        '/basmapvers/latestVer',
                        {dataId: pkid, prjId, sVer}
                    )

                    const {data, root} = parseMap(dataMap)
                    this.data = data
                    const _n = this.nodeProxy(this.root)
                    _n.replace(root)
                    await this.actions.saveMap()
                    await this.actions.publishMap()
                },

                {action: '撤销修订地图'},
            )
        )
    }
}
